import {FaChevronDown, FaEye, FaFileExport, FaSearch, FaTimes} from "react-icons/fa";
import {cities} from "../../../../dummyData/cities";
import React, {useEffect, useState} from "react";
import {collection, doc, getDocs, updateDoc} from "firebase/firestore";
import {db} from "../../../../firebase/firebase";
import * as XLSX from "xlsx";
import {useForm} from 'react-hook-form';
import DataTable from "react-data-table-component";
import {Button, Modal} from "react-bootstrap";
import "./styles.css";
import ControlledCheckBoxField from "../../../../Components/ControlledCheckBoxField";
import ControlledSelect from "../../../../Components/ControlledSelect";
import {RESPONSE_STATUS} from "../../../../dummyData/dummyData";
import ControlledTextAreaField from "../../../../Components/ControlledTextAreaField";

const UnregisterUsers = () => {


    const [selectedData, setSelectedData] = useState(null);
    const [userDetails, setUserDetails] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [loading, setLoading] = useState(true);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [show, setShow] = useState(false);

    console.log(userDetails, "userDetails==========")

    const {
        control,
        reset,
        handleSubmit,
        formState: {errors}
    } = useForm({
        defaultValues: {
            isCalled: false,
            specialNode: '',
            status: []
        }
    })

    const toggle = () => setShow(!show);
    const handleSelectData = (row) => {
        setSelectedData(row)
        toggle()
    };

    const fetchUserDetails = async () => {

        setLoading(true)
        try {
            const querySnapshot = await getDocs(collection(db, "getUserDetails"));
            const details = [];

            querySnapshot.forEach((doc) => {
                details.push({id: doc.id, ...doc.data()});
            });

            setUserDetails(details);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching user details:", error);
            setLoading(false);
        }
    };


    useEffect(() => {

        const today = new Date();
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(today.getDate() - 6);

        const formatDate = (date) => {
            return date.toISOString().split("T")[0];
        };

        setStartDate(formatDate(sevenDaysAgo));
        setEndDate(formatDate(today));


        fetchUserDetails();
    }, []);


    const filteredUsers = userDetails.map((user) => {
        const name = user.name || "";
        const email = user.email || "";
        const phoneNumber = user.phoneNumber || "";
        const district = user.district || "";

        let createdAt = null;
        try {
            if (user.createdAt) {
                createdAt = user.createdAt.toDate
                    ? user.createdAt.toDate()
                    : new Date(user.createdAt);
            }
        } catch (e) {
            console.warn("Invalid date format for user:", user.id, user.createdAt);
        }

        return {
            ...user,
            name,
            email,
            phoneNumber,
            district,
            createdAt,
        };
    })
        .filter((user) => {
            const matchesSearch =
                user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.phoneNumber.includes(searchTerm);

            const matchesDistrict =
                selectedDistrict === "" ||
                user.district.toLowerCase() === selectedDistrict.toLowerCase();


            let matchesDate = true;
            if (startDate || endDate) {
                if (!user.createdAt) {
                    matchesDate = false;
                } else {
                    const userDate = user.createdAt;
                    const start = startDate ? new Date(startDate) : null;
                    const end = endDate ? new Date(endDate) : null;

                    matchesDate =
                        (!start || userDate >= start) && (!end || userDate <= end);
                }
            }

            // console.log("Matches Date:", matchesDate);

            return matchesSearch && matchesDistrict && matchesDate;
        })
        .sort((a, b) => {
            const dateA = a.createdAt ? new Date(a.createdAt) : new Date(0);
            const dateB = b.createdAt ? new Date(b.createdAt) : new Date(0);
            return dateB.getTime() - dateA.getTime();
        });

    const exportToExcel = (data) => {
        // Prepare the data for export
        const excelData = data.map((user, index) => ({
            "#": index + 1,
            Name: user.name,
            City: user.city || "-",
            "Phone Number": user.phoneNumber || "-",
            Age: user.age || "-",
            District: user.district || "-",
            Email: user.email || "-",
            "Registration Date": user.createdAt
                ? user.createdAt.toLocaleDateString()
                : "-",
        }));

        // Create a new workbook
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, "Unregistered Users");

        // Generate the Excel file and trigger download
        XLSX.writeFile(wb, "Unregistered_Users.xlsx");
    };

    // const handleViewDetails = (user) => {
    //     navigate(`/admin/user-details/${user?.id}`, {state: {user}});
    // };

    const getAvatarColor = (name) => {
        if (!name || typeof name !== "string" || name.length === 0) {
            return "#C5A3FF";
        }

        const colors = ["#C5A3FF", "#A3FFC5", "#FFC5A3", "#A3C5FF", "#90EE90"];
        const initial = name.charCodeAt(0);
        return colors[initial % colors.length];
    };

    const fmt = (v) => (v === null || v === undefined || v === "" ? "—" : v);

    const licenses = Array.isArray(selectedData?.licenses) ? selectedData.licenses : [];

    const USER_LIST_COLUMNS = [
        {
            name: "*", selector: (row) => <div className={'d-flex justify-content-center align-items-center'}>
                <div
                    className="user-avatar"
                    style={{backgroundColor: getAvatarColor(row.name)}}
                >
                    <span>{row.name?.charAt(0) || "U"}</span>
                </div>
                <span>{row.name}</span>
            </div>, sortable: true
        },
        {
            name: "Create Date",
            selector: (row) => (
                row?.createdAt
                    ? new Date(row.createdAt).toLocaleString("en-GB", {
                        dateStyle: "medium",
                        timeStyle: "short",
                    })
                    : "create at"
            ),
            sortable: true
        },
        {name: "Phone", selector: (row) => row?.phoneNumber, sortable: true},
        {name: "District", selector: (row) => row.district},
        {name: "City", selector: (row) => row.closedCity},
        {name: "Status", selector: (row) => row?.status},
        {
            name: "Action",
            right: true,
            selector: (row) => <Button variant="primary" onClick={() => handleSelectData(row)}>
                <FaEye/>
            </Button>
        },
        // {
        //     name: "Joined Date", selector: (row) =>
        //         <button
        //             className="btn btn-view"
        //             onClick={() => handleViewDetails(row)}
        //         >
        //             <FaEye/>
        //         </button>
        //     , right: true
        // },
    ]

    const onSubmit = async (data) => {

        try {

            if (!selectedData?.id) {
                console.error("No selectedData.id found");
                return;
            }

            const docRef = doc(db, "getUserDetails", selectedData.id);

            // Update only the fields from the form
            await updateDoc(docRef, {
                ...selectedData,
                isCalled: data.isCalled,
                specialNode: data.specialNode,
                status: data.status.label,
                updatedAt: new Date().toISOString(),
            });

            toggle()
            reset()
        } catch (error) {
            console.error("Error updating document:", error);
        }
    }

    if (loading) {
        return <>Loading ...... !</>;
    }

    return (
        <div className="admin-home-card">

            <div className="add-members-section">
                <div className="filters-container">
                    {(
                        <div className="search-filter">
                            <div className="search-input-container">
                                <FaSearch className="search-icon"/>
                                <input
                                    type="text"
                                    placeholder="Search by name, email or phone..."
                                    className="search-input"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                {searchTerm && (
                                    <button
                                        className="clear-search"
                                        onClick={() => setSearchTerm("")}
                                    >
                                        <FaTimes/>
                                    </button>
                                )}
                            </div>
                        </div>
                    ) && false}

                    {/* Date Range Filter */}
                    <div className="date-range-filter">
                        <div className="date-input-group">
                            <label htmlFor="start-date">From</label>
                            <div className="date-input-container">
                                <input
                                    id="start-date"
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    className="date-input"
                                    max={endDate || undefined}
                                />
                                {startDate && (
                                    <button
                                        className="clear-date"
                                        onClick={() => setStartDate("")}
                                    >
                                        <FaTimes/>
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="date-input-group">
                            <label htmlFor="end-date">To</label>
                            <div className="date-input-container">
                                <input
                                    id="end-date"
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    className="date-input"
                                    min={startDate || undefined}
                                />
                                {endDate && (
                                    <button
                                        className="clear-date"
                                        onClick={() => setEndDate("")}
                                    >
                                        <FaTimes/>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* District Dropdown */}
                    <div className="dropdown-filter">
                        <label htmlFor="district-select">District</label>
                        <div className="custom-select-container">
                            <select
                                id="district-select"
                                value={selectedDistrict}
                                onChange={(e) => setSelectedDistrict(e.target.value)}
                                className="district-select"
                            >
                                <option value="">All Districts</option>
                                {Object.keys(cities).map((district, index) => (
                                    <option key={index} value={district}>
                                        {district}
                                    </option>
                                ))}
                            </select>
                            <FaChevronDown className="dropdown-arrow"/>
                        </div>
                    </div>

                    {/* Export Button */}
                    <button
                        className="export-button"
                        onClick={() => {
                            if (filteredUsers.length > 0) {
                                exportToExcel(filteredUsers);
                            } else {
                                // toast.warning("No users to export");
                            }
                        }}
                        disabled={filteredUsers.length === 0}
                    >
                        <FaFileExport className="export-icon"/>
                        <span>Excel</span>
                    </button>
                </div>

                <DataTable
                    columns={USER_LIST_COLUMNS}
                    data={filteredUsers}
                    pagination
                    highlightOnHover
                    striped
                />
            </div>

            <Modal
                show={show}
                onHide={toggle}
                backdrop="static"
                keyboard={false}
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {selectedData?.name}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <table className="details-table">
                            <tbody>
                            <tr>
                                <td className="label">Name</td>
                                <td className="value">{fmt(selectedData?.name)}</td>
                            </tr>
                            <tr>
                                <td className="label">Age</td>
                                <td className="value">{fmt(selectedData?.age)}</td>
                            </tr>
                            <tr>
                                <td className="label">Gender</td>
                                <td className="value">
                                    {fmt(
                                        selectedData?.gender?.toString().charAt(0).toUpperCase() +
                                        (selectedData?.gender?.toString().slice(1) || "")
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td className="label">Phone</td>
                                <td className="value">
                                    {selectedData?.phoneNumber ? (
                                        <a href={`tel:${selectedData.phoneNumber}`}>
                                            {selectedData.phoneNumber}
                                        </a>
                                    ) : (
                                        "—"
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td className="label">Email</td>
                                <td className="value">
                                    {selectedData?.email ? (
                                        <a href={`mailto:${selectedData.email}`}>
                                            {selectedData.email}
                                        </a>
                                    ) : (
                                        "—"
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td className="label">District</td>
                                <td className="value">{fmt(selectedData?.district)}</td>
                            </tr>
                            <tr>
                                <td className="label">Closest City</td>
                                <td className="value">{fmt(selectedData?.closedCity)}</td>
                            </tr>
                            <tr>
                                <td className="label">Hope Driving Licenses</td>
                                <td className="value">
                                    {licenses.length ? (
                                        <div className="chips">
                                            {licenses.map((lic, i) => (
                                                <span className="chip" key={`${lic}-${i}`}>
                          {lic}
                        </span>
                                            ))}
                                        </div>
                                    ) : (
                                        "—"
                                    )}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <hr/>
                        <div>
                            <ControlledCheckBoxField
                                label={'Called'}
                                inputName="isCalled" rules={{required: false}}
                                errors={errors} invalid={errors.isCalled && true} control={control}
                                isRequired={false}/>
                        </div>
                        <div>
                            <ControlledSelect
                                label={"Status"}
                                inputName="status"
                                isRequired={true}
                                invalid={errors.status && true}
                                control={control}
                                rules={{required: true}}
                                errors={errors}
                                optionsList={RESPONSE_STATUS}
                            />
                        </div>
                        <div>
                            <ControlledTextAreaField label="Special Node"
                                                     rules={{
                                                         required: false,
                                                         min: 2
                                                     }} inputName="specialNode" placeholder=""
                                                     errors={errors} invalid={errors.specialNode && true}
                                                     control={control}/>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={toggle}>
                            Close
                        </Button>
                        <Button variant="primary" type="submit">Save</Button>
                    </Modal.Footer>
                </form>
            </Modal>

        </div>
    )
}

export default UnregisterUsers
